import React, { useState, useEffect } from "react";
import Header from "../../reusables/Header";
import { Button, Card, message, Spin } from "antd";
import "./home.scss";
import SignupModal from "./partials/SignupModal";
import Footer from "../../reusables/Footer";
import { useQuery } from "@apollo/client";
import { Link, Redirect, useHistory } from "react-router-dom";
import { LIST_PARTNERS } from "../../constants";
import { Helmet } from "react-helmet";
import { getCountryCode } from "../../redux/actions/general";
import {
	HiArrowRight,
	HiOutlineGift,
	HiOutlineSparkles,
	HiOutlineBuildingStorefront,
	HiOutlineShieldCheck,
} from "react-icons/hi2";

function HomePage() {
	const history = useHistory();
	const [showLoginModal, setShowLoginModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [redirect, setRedirect] = useState(null);
	const [currentArea, setcurrentArea] = useState(null);
	const baseUrl = process.env.REACT_APP_CUSTOMER_REDIRECT_BASE_URL;
	const redirecTo = process.env.REACT_APP_REDIRCT_TO;
	const brandName = process.env.REACT_APP_BRAND_NAME || "Loystar";

	const { data: listPartnersData } = useQuery(LIST_PARTNERS, {
		onError: (error) => {
			message.error(error.message);
		},
	});

	const isUrlOrigin = window.location.href.includes("thecualashop.com");

	useEffect(() => {
		if (isUrlOrigin) {
			handleGetCurrentLocation();
		} else {
			window.location.replace("https://loystar.co");
		}
	}, []);

	const handleGetCurrentLocation = () => {
		getCountryCode()
		.then(res => {
		  if(res.status === 200){
			const country = res.data;
			console.log(res.data, isUrlOrigin)
			setcurrentArea(country);
			if(isUrlOrigin && country.country_name === "Nigeria"){
				return window.location = "https://thecualashop.com/cuala.ng";
			}
			
			if(isUrlOrigin && country.country_name === "United Kingdom"){
				return window.location = "https://thecualashop.com/cuala.uk";
			}
			
			return window.location = "https://loystar.co/shop";
		  }
		  window.location = "https://loystar.co/shop";
		})
		.catch(err => {
		  console.log("err", err);
		  
		})
	  }

	// Light-mode body
	useEffect(() => {
		const body = document.querySelector("body");
		body.style.background = "#FFFFFF";
		return () => {
			body.style.background = "";
		};
	}, []);

	const listPartners = listPartnersData?.listPartners || [];

	// Build programme type label
	const typeLabel = (t) =>
		t === "StampsProgram"
			? "Stamps"
			: t === "SimplePoints"
			? "Points"
			: t === "InstantRewards"
			? "Instant"
			: t === "CashRewards"
			? "Cash"
			: "Rewards";

	// Collect all loyalty programmes from partners for the featured grid
	const allOffers = listPartners.reduce((acc, partner) => {
		const programs = partner?.loyalty_programs || [];
		programs.forEach((prog) => {
			acc.push({ ...prog, merchantName: partner?.company_name, merchantUrl: partner?.urewards_id });
		});
		return acc;
	}, []);

	if (redirect) return <Redirect push to={redirect} />;

	return (
		<>
			<Helmet>
				<title>{brandName} Shop — Rewards Marketplace</title>
				<meta name="description" content={`Discover local brands, earn rewards, and unlock exclusive deals on the ${brandName} marketplace.`} />
			</Helmet>

			<Header openLoginModal={() => setShowLoginModal(true)} />

			<main className="ls-home">
				<Card loading={loading} style={{ background: "transparent", border: "none" }}>
					{/* ========== Hero ========== */}
					<section className="ls-home-hero">
						<div className="ls-home-hero__grid">
							<div className="ls-home-hero__content">
								<div className="ls-home-hero__badge">
									<HiOutlineSparkles /> Rewards Marketplace
								</div>
								<h1 className="ls-home-hero__title">
									Shop local.{" "}
									<span style={{ display: "block" }}>Earn rewards.</span>
								</h1>
								<p className="ls-home-hero__subtitle">
									Discover brands in your area, collect loyalty points with every
									purchase, and redeem exclusive rewards — all in one place.
								</p>
								<div className="ls-home-hero__actions">
									<Button
										type="primary"
										size="large"
										onClick={() => setRedirect("/discover")}
									>
										Explore stores <HiArrowRight style={{ marginLeft: 6, verticalAlign: "-2px" }} />
									</Button>
									<Button
										size="large"
										onClick={() => setShowLoginModal(true)}
									>
										Sign in to track rewards
									</Button>
								</div>
							</div>

							<div className="ls-home-hero__stats">
								<div className="ls-home-hero__stat-card">
									<span className="stat-num">{listPartners.length || "—"}</span>
									<span className="stat-lbl">Partner brands</span>
								</div>
								<div className="ls-home-hero__stat-card">
									<span className="stat-num">{allOffers.length || "—"}</span>
									<span className="stat-lbl">Active reward programs</span>
								</div>
								<div className="ls-home-hero__stat-card">
									<span className="stat-num">
										<HiOutlineGift style={{ fontSize: 28, verticalAlign: "-4px" }} />
									</span>
									<span className="stat-lbl">Points, stamps &amp; instant rewards</span>
								</div>
								<div className="ls-home-hero__stat-card">
									<span className="stat-num">
										<HiOutlineShieldCheck style={{ fontSize: 28, verticalAlign: "-4px" }} />
									</span>
									<span className="stat-lbl">Secure &amp; free to join</span>
								</div>
							</div>
						</div>
					</section>

					{/* ========== Featured Rewards ========== */}
					{allOffers.length > 0 && (
						<section className="ls-home-section">
							<div className="ls-home-section__header">
								<div>
									<h2 className="ls-home-section__title">Featured Rewards</h2>
									<p className="ls-home-section__subtitle">
										Top loyalty programs from our partner brands
									</p>
								</div>
								<Link to="/discover" className="ls-home-section__viewall">
									View all
								</Link>
							</div>

							<div className="ls-offers-grid">
								{allOffers.slice(0, 6).map((offer, idx) => (
									<div
										key={offer?.id || idx}
										className="ls-offer-card"
										onClick={() =>
											offer.merchantUrl
												? setRedirect(`/${offer.merchantUrl}`)
												: null
										}
									>
										<div>
											<span className="ls-offer-card__type">
												{typeLabel(offer?.program_type)}
											</span>
											{offer?.reward && (
												<p className="ls-offer-card__reward">{offer.reward}</p>
											)}
											<p className="ls-offer-card__name">{offer?.name}</p>
											{offer?.program_type === "StampsProgram" && offer?.threshold && (
												<p className="ls-offer-card__rule">
													Collect {offer.threshold} stamps to redeem
												</p>
											)}
											{offer?.program_type === "SimplePoints" && offer?.threshold && (
												<p className="ls-offer-card__rule">
													Earn {offer?.points || "—"} pts per purchase · redeem at {offer.threshold}
												</p>
											)}
										</div>
										<div className="ls-offer-card__footer">
											<span className="merchant-name">
												{offer.merchantName}
											</span>
											<span className="claim-tag">
												Join <HiArrowRight />
											</span>
										</div>
									</div>
								))}
							</div>
						</section>
					)}

					{/* ========== Brand Directory ========== */}
					{listPartners.length > 0 && (
						<section className="ls-home-section">
							<div className="ls-home-section__header">
								<div>
									<h2 className="ls-home-section__title">Brands</h2>
									<p className="ls-home-section__subtitle">
										Browse stores with active reward programs
									</p>
								</div>
								<Link to="/discover" className="ls-home-section__viewall">
									View all
								</Link>
							</div>

							<div className="ls-brands-grid">
								{listPartners.slice(0, 8).map((partner, idx) => {
									const initial = (partner?.company_name || "S")
										.trim()
										.charAt(0)
										.toUpperCase();
									const programCount = partner?.loyalty_programs?.length || 0;
									return (
										<div
											key={partner?.id || idx}
											className="ls-brand-card"
											onClick={() =>
												partner?.urewards_id
													? setRedirect(`/${partner.urewards_id}`)
													: null
											}
										>
											<div
												className="ls-brand-card__cover"
												style={
													partner?.banner
														? { backgroundImage: `url(${partner.banner})` }
														: undefined
												}
											>
												{partner?.image ? (
													<img
														className="ls-brand-card__logo"
														src={partner.image}
														alt={`${partner.company_name} logo`}
													/>
												) : (
													<div className="ls-brand-card__logo ls-brand-card__logo--initial">
														{initial}
													</div>
												)}
											</div>
											<div className="ls-brand-card__body">
												<p className="ls-brand-card__name">
													{partner?.company_name}
												</p>
												{partner?.business_type && (
													<p className="ls-brand-card__category">
														{partner.business_type}
													</p>
												)}
												{programCount > 0 && (
													<span className="ls-brand-card__perk">
														<HiOutlineBuildingStorefront
															style={{ verticalAlign: "-2px", marginRight: 4 }}
														/>
														{programCount} reward program{programCount > 1 ? "s" : ""}
													</span>
												)}
											</div>
										</div>
									);
								})}
							</div>
						</section>
					)}

					{/* ========== Footer links ========== */}
					<div
						style={{
							borderTop: "1px solid #EAEAEA",
							margin: "48px 0 0",
							padding: "24px 0",
							textAlign: "center",
						}}
					>
						<a
							href="/"
							style={{ color: "#888", fontSize: 13, textDecoration: "underline" }}
						>
							Terms and Conditions
						</a>
					</div>
				</Card>
			</main>

			<Footer active="home" />

			{showLoginModal && (
				<SignupModal
					visible={showLoginModal}
					onCancel={() => setShowLoginModal(false)}
				/>
			)}
		</>
	);
}

export default HomePage;
